// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M4 8L8 12L12 8M8 12V4'];
